import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';

const SectionCard1: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.SectionCard1');
    const getParams = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const utmParams: any = {};
        const utmSource = urlParams.get('utm_source');
        const utmMedium = urlParams.get('utm_medium');
        const utmCampaign = urlParams.get('utm_campaign');

        if (!!utmSource) {
            utmParams.utm_source = utmSource;
        }

        if (!!utmMedium) {
            utmParams.utm_medium = utmMedium;
        }

        if (!!utmCampaign) {
            utmParams.utm_campaign = utmCampaign;
        }
        utmParams.terminal = 'ecoflow';
        return utmParams;
    };

    const _getUrl = () => {
        if (typeof window === 'undefined') {
            return '';
        }
        const params: any = getParams();
        let baseUrl = `https://energy.ecoflow.com/${locale}/en/na/locationInfo`;

        if (process.env.NEXT_PUBLIC_MODY === 'prd') {
            baseUrl = `https://energy.ecoflow.com/${locale}/en/na/locationInfo`;
        }

        // 创建 URLSearchParams 实例并自动处理 params 中的字段
        const urlParams = new URLSearchParams(params);

        // 拼接参数到 URL
        const finalUrl = `${baseUrl}?${urlParams.toString()}`;
        return finalUrl;
    };

    const finalUrl = _getUrl();

    return (
        <div className={styles.SectionCard1} id="SectionCard1" data-section-id={styles.SectionCard1} data-section-title={t('title')}>
            <EcoSpace />
            <EcoSectionCommon
                title={t('title')}
                desc={t('desc')}
                lChildren={t('btn')}
                lHref={finalUrl}
                lDataLayer={{
                    __btn_id1: styles.SectionCard1,
                    __btn_id2: finalUrl,
                }}
            />
            <div className="eco-content">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1755151836392/Group%201000007319.png"
                    pad="https://websiteoss.ecoflow.com/upload/image/1755151836392/Group%201000007319.png"
                    h5="https://websiteoss.ecoflow.com/upload/image/1755596401187/Frame%201612690338%20(1).png"
                />
                <div className="footer-desc">
                    {t.rich('footer_desc', {
                        t: (text: string) => (
                            <EcoLink className="terms-link" href="https://zenodo.org/records/15801701" target="_blank">
                                {text}
                            </EcoLink>
                        ),
                        p: (text: string) => (
                            <EcoLink
                                className="terms-link"
                                href="https://www.cnbc.com/2025/07/14/how-much-trumps-big-beautiful-bill-could-raise-electricity-costs.html"
                                target="_blank"
                            >
                                {text}
                            </EcoLink>
                        ),
                    })}
                </div>
            </div>
            <EcoSpace />
        </div>
    );
};

export default SectionCard1;
